import { Expose, Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class ExpenseSheetSummaryItemDto {
  @Expose()
  expenseTypeId: string | null;

  @Expose()
  expenseTypeName: string | null;

  @Expose()
  @Transform(({ value }) => toEuros(value))
  total: number;

  @Expose()
  count: number;
}
